import { Category, PartsProduct } from '@app/react/const/type';
import { SELECT_ALL } from '@component/index';

type RT = Array<{ subCategoryId: number; subCategoryName: string, length: number }>;

export const buildSubCategoryLength = (
    categoryData: Array<Category>,
    partsData: Array<PartsProduct>,
    selectCategoryId: number,
): RT => (categoryData.reduce((acc, { categoryId, subCategoryData }) => {
    if (selectCategoryId !== SELECT_ALL && selectCategoryId !== categoryId) {
        return acc;
    }

    const x = subCategoryData.map(({ subCategoryId, subCategoryName }) => {
        const { length } = partsData
            .filter((cat) => cat.subCategoryId === subCategoryId);
        return {
            subCategoryId,
            subCategoryName,
            length,
        };
    });

    return acc.concat(x);
}, [] as RT));
